export const projectName = '777juegos'
export const projectStyledName = '777juegos'
export const projectDomainName = '777juegos.com'
export const projectKey = '777juegoscom'
export const projectNotificationName = '777juegos'
export const staticServerDomain = 'gcatg.com'

export const altenarBetHistoryUrl = 'https://dobets365.com/bet-history-frame'
export const newBCraftServicesUrl = 'https://new.bcraftservices.com'
export const sliderUrl = 'https://gcatg.com/services/content'
export const sliderImageBaseUrl = 'https://images.gcatg.com/media'

export const defaultCurrency = 'ARS'

export const defaultDateFormat = 'DD.MM.YYYY'
export const defaultTimeFormat = 'HH:mm:ss'
export const defaultViewDateFormat = `${defaultTimeFormat} ${defaultDateFormat}`

// Pragmatic DGA
export const PRAGMATIC_DGA_WS_URL = 'dga.pragmaticplaylive.net'

export const PRAGMATIC_DGA_CASINO_ID = 'ppcdh00000006107'

export const altenarScriptId = 'altenar-script'

export const betbyScriptId = 'betby-script'
